import type { NodeDesignsEvent } from "../../reducer/index.ts";

export const eventQueueCreate = () => {
  const items: NodeDesignsEvent[] = [];
  return {
    enqueue: (item: NodeDesignsEvent) => {
      items.push(item);
    },
    dequeue: () => {
      return items.shift();
    },
  };
};

export type EventQueue = ReturnType<typeof eventQueueCreate>;
